//URLs
export const APP_BASE_NAME = "/tassa-auto";
export const SLASH = "/";
export const URL_TASSAAUTO = APP_BASE_NAME + SLASH;
export const URL_SERVIZI_ONLINE = "/servizi-online";
export const URL_SERVIZI_ONLINE_PROTECTED = "/servizi-online/protected/home";
export const AUTH_MODE_PUBLIC = "public";
export const AUTH_MODE_PROTECTED = "protected";
export const URL_TASSAAUTO_SERVIZI_ONLINE = APP_BASE_NAME + URL_SERVIZI_ONLINE + SLASH;
export const URL_CALCOLAPAGA_PUBLIC = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PUBLIC + "/calcolapaga";
export const URL_CALCOLAPAGA_PROTECTED = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PROTECTED + "/calcolapaga";
export const URL_CONSULTAZIONE_PROTECTED = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PROTECTED + "/consultazione";
export const URL_RIMBORSI_PROTECTED = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PROTECTED + "/rimborsi";
export const URL_ESITOPAGAMENTO_PUBLIC = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PUBLIC + "/esitopagamento" + SLASH;
export const URL_ESITOPAGAMENTO_PROTECTED = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PROTECTED + "/esitopagamento" + SLASH;
export const URL_PRIVACY_POLICY_PUBLIC = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PUBLIC + "/privacy-policy";
export const URL_PRIVACY_POLICY_PUBLIC_EXT = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PUBLIC + "/privacy-policy-ext";
export const URL_PAGAMENTO_MOD3_PUBLIC = URL_SERVIZI_ONLINE + SLASH + AUTH_MODE_PUBLIC + "/modello3";
export const URL_EXT_PAGAMENTO_MOD3 = "https://nrp.regione.liguria.it/portalecittadino/pub/liguriaPay_02Page/1";

//CALCOLA E PAGA
export const STR_CALCOLAPAGA_TITOLO = 'Calcola e Paga';
export const STR_CALCOLAPAGA_INPUT = 'Inserimento Dati';
export const STR_CALCOLAPAGA_VERIFICA = 'Verifica';
export const STR_CALCOLAPAGA_CALCOLO = 'Calcolo';
export const STR_CALCOLAPAGA_PAGAMENTO = 'Pagamento';
export const CALCOLAPAGA_STEPS = [STR_CALCOLAPAGA_INPUT, STR_CALCOLAPAGA_VERIFICA, STR_CALCOLAPAGA_CALCOLO, STR_CALCOLAPAGA_PAGAMENTO];

export const STEP_0 = 0;
export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;

export const ESITO_CALCOLO_PAGABILE = "PAGABILE";
export const ESITO_CALCOLO_NO_MATCH = "NO_MATCH";
export const ESITO_CALCOLO_NO_VEICOLO_MATCH = "NO_VEICOLO_MATCH";
export const ESITO_CALCOLO_NO_MATCH_CF = "NO_MATCH_CF";
export const ESITO_CALCOLO_NO_MATCH_ESE = "NO_MATCH_ESE";
export const ESITO_CALCOLO_NON_PAGABILE = "NON_PAGABILE";

export const ESITO_CALCOLO_ERRORE = "ERRORE";

export const RADIO_LABEL_CICLOMOTORE = "Ciclomotore";//"ciclomotore"; //
export const RADIO_LABEL_QUADRICICLO_LEGGERO = "Quadriciclo leggero";//"quadriciclo_leggero"; //
export const RADIO_LABEL_TARGA_PROVA_AUTO = "Targa prova autoveicolo";//"tp_auto";//
export const RADIO_LABEL_TARGA_PROVA_MOTO = "Targa prova motoveicolo";//"tp_moto";//
export const RADIO_LABEL_TARGA_PROVA_CICLO = "Targa prova ciclomotore";//"tp_ciclo";//
export const RADIO_LABEL_TARGA_PROVA_RIMORCHIO = "Targa prova rimorchio";//"tp_rim";//
export const RADIO_LABEL_ALTRI_CASI = "Altri casi"//"altri_casi";// 

export const TIPO_VEICOLO_CICLOMOTORE = "C";
export const TIPO_VEICOLO_QUADRICICLO_LEGGERO = "Q";
export const TIPO_VEICOLO_TARGA_PROVA_AUTO = "PA";
export const TIPO_VEICOLO_TARGA_PROVA_MOTO = "PM";
export const TIPO_VEICOLO_TARGA_PROVA_CICLO = "PC";
export const TIPO_VEICOLO_TARGA_PROVA_RIMORCHIO = "PR";
export const TIPO_VEICOLO_ALTRI_CASI = "Altri casi";

export const ALTRI_CASI_VEICOLI_STORICI = "veicoli_storici";
export const ALTRI_CASI_AFI = "afi";
export const ALTRI_CASI_ESCURSIONISTI_ESTERI = "ee";
export const ALTRI_CASI_ALTRO = "altro";
export const CRISI_FALLIMENTO = "crisi_fallimento";

export const RADIO_LABEL_REIMM_VEICOLI_STORICI = "Reimmatricolazione veicoli storici";
export const RADIO_LABEL_ALTRI_CASI_AFI = "A.F.I. (veicoli Forze Alleate in Italia)";
export const RADIO_LABEL_ALTRI_CASI_EE = "E.E. (veicoli Escursionisti Esteri)";
export const RADIO_LABEL_ALTRI_CASI_ALTRO = "Altro";
export const RADIO_LABEL_CRISI_FALLIMENTO = "CRISI/FALLIMENTO";
//CONSULTAZIONE
export const STR_CONSULTAZIONE_TITOLO = 'Consultazione';
export const STR_CONSULTAZIONE_INPUT = 'Inserimento Dati';
export const STR_CONSULTAZIONE_VEICOLI = 'Elenco veicoli';
export const STR_CONSULTAZIONE_DETTAGLIO = 'Dettaglio';
export const ARRAY_CONSULTAZIONE_STEPS = [STR_CONSULTAZIONE_INPUT, STR_CONSULTAZIONE_VEICOLI, STR_CONSULTAZIONE_DETTAGLIO];
export const ULTIMI_TRE_ANNI = 3; //conta anche l'anno corrente
export const CINQUE_ANNI = 5;

export const MODO_PAGAMENTO_NON_ANNUALE = "NON_ANNUALE";

export const CONS_CHOICE_PAGAMENTO_DETTAGLI = 'Dettagli pagamento';
export const CONS_CHOICE_PAGAMENTO_CALCOLO = 'Riepilogo calcolo';

export const CONS_CHOICE_DETTAGLI_VEICOLO = 'Dettagli veicolo';
export const CONS_CHOICE_DETTAGLI_PAGAMENTI = 'Elenco pagamenti';

export const BUTTON_LABEL_ISCRIVITI_AL_SERVIZIO = "Iscriviti al servizio avvisi di scadenza";
//STALIGK-860
export const LUNGHEZZA_MIN_NUM_TELAIO = 10;
export const LUNGHEZZA_MAX_NUM_TELAIO = 17;

//STALIGK-835
//export const BUTTON_LABEL_RISULTI_ISCRITTO = "Risulti iscritto agli avvisi di scadenza se vuoi puoi cambiare la tua mail";
export const BUTTON_LABEL_RISULTI_ISCRITTO = "Annulla l'iscrizione al servizio / Cambia la tua mail";
export const STR_GIA_ISCRITTO_BEFORE = "Risulti già iscritto agli avvisi di scadenza con il seguente indirizzo email:";
export const STR_GIA_ISCRITTO_AFTER = " - puoi annullare l'iscrizione oppure cambiare la tua mail cliccando sul pulsante sottostante";

export const LABEL_ISCRIVITI_AL_SERVIZIO = "Iscriviti al servizio"
export const LABEL_RIMUOVITI_DAL_SERVIZIO = "Rimuoviti dal servizio";

//RIMBORSI
export const STR_RIMBORSI_TITOLO = 'Rimborsi';
export const STR_RIMBORSI_TITOLO_ELENCO_PAGAMENTI = 'Elenco pagamenti';
export const STR_RIMBORSI_TIPO_RIMBORSO = 'Tipo rimborso';
export const STR_RIMBORSI_INSERIMENTO_DATI = 'Inserimento dati';
export const STR_RIMBORSI_DETTAGLI = 'Dettagli';
export const STR_RIMBORSI_STEP1 = 'TODO';
export const NUM_MIN_ALLEGATI = 2;
export const NUM_MAX_ALLEGATI = 5;
const NUM_BYTES = 1024 * 1024;
export const NUM_MEGABYTES = 2;
export const MAX_SIZE_ALLEGATO_IN_BYTES = NUM_MEGABYTES * NUM_BYTES;
//STALIGK-792: mod. estensioni e attachment_types accettati ***
//export const FILE_TYPE_WHITELIST = "PDF,JPG,JPEG,PNG,TIFF,JFIF,PJP,PJPEG";
//export const ACCEPTED_ATTACHMENT_TYPES = "image/png, image/jpeg, application/pdf";
export const FILE_TYPE_WHITELIST = "PDF,JPG,JPEG";
export const ACCEPTED_ATTACHMENT_TYPES = "image/jpg, image/jpeg, application/pdf";

export const RIM_CHOICE_RIMBORSO_ELENCORICHIESTE = 'Elenco richieste di rimborso';
export const RIM_CHOICE_RIMBORSO_ELENCOVEICOLI = 'Elenco veicoli';
export const RIM_CHOICE_RIMBORSO_CICLOMOTORI = 'Ciclomotore';
export const RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE = 'Veicolo aziendale';
export const RIM_CHOICE_RIMBORSO_FUORIREGIONE = 'Residente fuori Liguria';
//STALIGK-793
export const RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE = 'Veicolo aziendale fuori Liguria';
export const RIM_CHOICE_RIMBORSO_EREDI = 'Dati Richiedente';
export const RIM_CHOICE_RIMBORSO_LEASING = 'Dati Proprietario Leasing';
export const RIM_CHOICE_RIMBORSO_INTERMEDIARI = 'Intermediario della riscossione';
export const RIM_CHOICE_DETTAGLI_DETTAGLI = 'Dettagli';
export const RIM_CHOICE_DETTAGLI_PAGAMENTI = 'Pagamenti';
export const RIM_CHOICE_PAGAMENTO_VISUALIZZA = 'Visualizza';
export const RIM_CHOICE_PAGAMENTO_RIMBORSA = 'Chiedi rimborso';
export const RIM_CHOICE_PAGAMENTO_ALLINEA = 'Chiedi allineamento';

export const RIM_TIPO_PROPRIETARIO_POSSESSORE = "P";
export const RIM_TIPO_PROPRIETARIO_INTERMEDIARIO = "I";
export const RIM_TIPO_PROPRIETARIO_FUORI_REGIONE = "O";

export const BUTTON_LABEL_DA_PAGARE = "DA PAGARE";

export const VARIANT_CONFIRMED = "confirmed";
export const VARIANT_ACTIVE = "active";


//PAGAMENTO LANDING PAGE
export const STR_ESITO_OPERAZIONE_TITOLO = 'Esito operazione:';
export const STR_ESITO_PAGAMENTO_POSITIVO = 'Pagamento completato';
export const STR_ESITO_PAGAMENTO_NEGATIVO = 'Pagamento fallito';
export const STR_ESITO_RICHIESTA_INVIATA = 'Richiesta inviata';
export const STR_ESITO_OK = 'ok';
export const STR_ESITO_KO = 'ko';

//Privacy
export const STR_PRIVACY_POLICY_TITOLO = "Privacy policy";

//BUTTONS
export const STR_BUTTON_AVANTI = 'Avanti';
export const STR_BUTTON_INDIETRO = 'Indietro';
export const STR_BUTTON_TORNA_A_ELENCO_PAGAMENTI = 'Torna a ' + STR_RIMBORSI_TITOLO_ELENCO_PAGAMENTI;
export const STR_BUTTON_TORNA_A_TIPO_RIMBORSO = 'Torna a ' + STR_RIMBORSI_TIPO_RIMBORSO;
export const STR_BUTTON_RESET = 'Esci';

//COMPONENTS PROPERTIES
export const STR_STEPPER_VARIANT_CONFIRMED = "confirmed"
export const STR_STEPPER_VARIANT_ACTIVE = "active"
export const STR_STEPPER_VARIANT_INACTIVE = null;

//COMMON
export const STR_TEMPLATE_TITOLO = 'Template Page';
export const STR_404_TITOLO = 'Hai perso la strada?';
export const USER_IN_SESSION = "user";
export const EMPTY_STRING = "";

//SLALINK-1040
export const AVVISO_SCADENZA_MAIL = "Gli avvisi di scadenza verranno inviati esclusivamente per i veicoli con periodicità annuale";
export const AVVISO_MANCATO_RICEVIMENTO = "Il mancato ricevimento, per qualsiasi motivo, dell'avviso di scadenza non può costituire giustificazione del mancato pagamento ed essere considerato 'errore scusabile' ai sensi dell'art. 6 del D.lgs n. 472/1997, pertanto ogni violazione all'obbligo del pagamento del tributo sarà perseguito a norma di legge.";
